import ProductHeroLayout from './ProductHeroLayout';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container'; 
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '../typography'; 
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import useStyles from './style.js';

export default function Contactus() {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));
  const classes = useStyles();
  return (
    <ProductHeroLayout backgroundClassName={classes.background}>
      <Grid  align='center'>
        <Typography  color="inherit" align="center" variant={matches ? "h3": "h2"} marked="center" className={classes.title}>
          Contáctenos
        </Typography>
        <Container maxWidth="md">
            <Typography color="inherit" align="center" variant="h5" className={classes.h5}>
              Puede dejarnos todas sus preguntas, comentarios y/o problemas. 
              Nuestro equipo esta disponible para brindarle soluciones efectivas a sus
              necesidades
            </Typography>
        </Container>
        <ExpandMoreIcon className={classes.arrowIcon} />
      </Grid>       
    </ProductHeroLayout>
  );
} 